// import React, { useEffect, useState } from "react"; import Menubar from "../Menubar";
// import { Container, Row, Col, Table, Button } from "react-bootstrap";
// import { store } from "../../App"; import { AiOutlineSearch } from "react-icons/ai";
// import { datetime, commonSelectProps } from "../utils/commonFunctions";
// import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal";
// import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik";
// import MasterService from "../../Services/MasterService"; import Select from 'react-select';
// import { IoReturnDownBack, IoReturnDownForward } from "react-icons/io5"; import { FaRegSave } from "react-icons/fa";
// import { IoIosReturnLeft } from "react-icons/io";

// export default function DistrictIndicatorcom() {
//   const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
//   let deptId = localStorage.getItem("deptid");

//   let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");
//   let mandalid = localStorage.getItem(ulbdeptlist.includes(deptId) ? "ulbid" : "mandalid");
//   let district = localStorage.getItem("districtid");
//   let roleid = localStorage.getItem("role");


//   let username = localStorage.getItem("username");
//   const [selectedMandalId, setSelectedMandalId] = useState(null);
//   const [Dist, setDist] = useState(null);
//   const [formikDist, setFormikDist] = useState(null);


//   const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); const [Deptlist, setDeptlist] = useState([]); const [distlist, setDistrictList] = useState();
//   const [searchDist, setSearchDist] = useState("");
//   const [maintablenb, setmaintablenb] = useState(true); const [selecteddist, setselecteddist] = useState(""); const [selectedmandal, setselectedmandal] = useState(""); const [yearList, setYearList] = useState([]); const [monthList, setMonthList] = useState([]); const [remarksStatus, setRemarksStatus] = useState({}); const [criteriaData, setCriteriaData] = useState([]);
//   const [remarksData, setRemarksData] = useState([]);
//   const [remarksText, setRemarksText] = useState({}); const [allAcceptance, setAllAcceptance] = useState(""); const [isFinalSubmitted, setIsFinalSubmitted] = useState(false);
//   const [statusCode, setStatusCode] = useState("");
//   const [statusId, setStatusId] = useState(null);
//   const [showDetailTable, setShowDetailTable] = useState(["2", "64", "5", "62"].includes(roleid));
//   const [distData, setDistData] = useState([]);


//   const formik = useFormik({
//     initialValues: { department_id: "", district_id: "", year: "", month: "" }
//   });



//   const ListTable = (payload) => {
//     setSearchDist("");
//     if (!payload.districtId) {
//       formik.setFieldValue("district_id", "");
//       setShowDetailTable(false); setmaintablenb(false); setDistData([]);
//       setCriteriaData([])
//       return;
//     }
//     store.dispatch({ type: "SHOW_SPINNER" });
//     KpiService.getCriteriaSelectionListData(payload).then((res) => {
//       if (res.data && res.data.dataList) {
//         const list = res.data.dataList; setDistData(list); setShowDetailTable(false)
//       }
//     }).catch((err) => {
//       console.error(err);
//     }).finally(() => {
//       store.dispatch({ type: "HIDE_SPINNER" });
//     });
//   }


//   useEffect(() => {
//     datetime(setcurrentdate, setcurrenttime);
//     let payload = { userId: username, districtId: district.toString() }
//     let param = { userId: username }
//     if (roleid === "2" || roleid === "64") {
//       fetchCriteriaAndRemarks(payload)
//     } else if (roleid === "5" || roleid === "62") {
//       setmaintablenb(false)
//     }
//     MasterService.getAllDepts(param).then((res) => {
//       if (res.data) {
//         let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); });
//         setDeptlist([{ dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? [])]);
//       }
//     });
//     MasterService.getfinyears().then((achievvalueres) => {
//       if (achievvalueres.data) {
//         let options = achievvalueres.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
//         setYearList(achievvalueres.data);
//       }
//     });
//     MasterService.getkpiMonths(param).then((res) => {
//       if (res.data && res.data.SCODE === "01") { setMonthList(res.data.SDESC || []); }
//       else { setMonthList([]); }
//     });
//     MasterService.getDistricts().then((res17) => {
//       if (res17.data) {
//         let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
//         setDistrictList([{ id: "0", value: "All" }, ...(res17.data ?? [])]);
//       }
//     });

//     if (["2", "3", "64"].includes(roleid)) { setselecteddist(localStorage.getItem("districtname")) }
//     if (["3",].includes(roleid)) { setselectedmandal(localStorage.getItem(ulbdeptlist.includes(deptId) ? "ulbname" : "mandalname")) }

//     if (["5", "62"].includes(roleid)) { formik.setFieldValue("department_id", deptId); }
//     if (["2", "3", "64"].includes(roleid)) { formik.setFieldValue("district_id", district); }
//   }, []);




//   const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white", wordBreak: "break-word" };

//   const mapRemarksToState = (criteriaList, remarksList) => {
//     const statusObj = {};
//     const remarksObj = {};

//     criteriaList.forEach((item, index) => {
//       // ✅ match remarks
//       const matched = remarksList.find(
//         (r) => String(r.cs_indicator_id) === String(item.cs_indicator_id)
//       );

//       // ✅ set acceptance FROM criteria API
//       if (item.is_required === true) {
//         statusObj[index] = "yes";
//       } else if (item.is_required === false) {
//         statusObj[index] = "no";
//       }

//       // ✅ set remarks FROM remarks API
//       remarksObj[index] = matched?.remarks || "";
//     });

//     console.log("FINAL STATUS:", statusObj);
//     console.log("FINAL REMARKS:", remarksObj);

//     setRemarksStatus(statusObj);
//     setRemarksText(remarksObj);
//   };
//   // const fetchCriteriaAndRemarks = (payload) => {
//   //   Promise.all([
//   //     KpiService.getCriteriaSelectionData({ ...payload, level: "District", }),
//   //     KpiService.getCriteriaSelectionRemarks({ ...payload, level: "District", }),
//   //   ]).then(([criteriaRes, remarksRes]) => {
//   //     const criteriaList = criteriaRes.data?.dataList || []; const remarksList = remarksRes.data?.dataList || []; setCriteriaData(criteriaList); setRemarksData(remarksList);
//   //     if (criteriaList.length > 0) { setStatusCode(criteriaList[0].status_code || ""); setStatusId(criteriaList[0].status_id || null); }
//   //     mapRemarksToState(criteriaList, remarksList);
//   //   }).catch(() => {
//   //     showAlertMessage("Failed to load data", "error");
//   //   });
//   // };

//   const fetchCriteriaAndRemarks = async (payload) => {
//     try {
//       const criteriaRes = await KpiService.getCriteriaSelectionData({
//         ...payload,
//         level: "District",
//       });

//       const scode = criteriaRes.data?.SCODE;

//       if (scode !== "01") {
//         showAlertMessage("Failed to load criteria data", "error");
//         return;
//       }

//       const criteriaList = criteriaRes.data?.dataList || [];
//       setCriteriaData(criteriaList);

//       if (criteriaList.length > 0) {
//         setStatusCode(criteriaList[0].status_code || "");
//         setStatusId(criteriaList[0].status_id || null);
//       }

//       const remarksRes = await KpiService.getCriteriaSelectionRemarks({
//         ...payload,
//         level: "District",
//       });

//       const remarksList = remarksRes.data?.dataList || [];
//       setRemarksData(remarksList);

//       mapRemarksToState(criteriaList, remarksList);

//     } catch (error) {
//       showAlertMessage("Failed to load data", "error");
//     }
//   };



//   const handleAcceptanceChange = (index, value) => {
//     const current = remarksStatus[index];

//     const updated = { ...remarksStatus, [index]: current === value ? undefined : value, };
//     setRemarksStatus(updated);
//     const economicItems = criteriaData.filter((item) => item.cs_indicator_type === "Economic");

//     const allYes = economicItems.every((_, i) => updated[i] === "yes");

//     const allNo = economicItems.every((_, i) => updated[i] === "no");

//     if (allYes) setAllAcceptance("yes");
//     else if (allNo) setAllAcceptance("no");
//     else setAllAcceptance("");
//   };
//   const validateBeforeForward = () => {
//     for (let i = 0; i < criteriaData.length; i++) {
//       const item = criteriaData[i];
//       if (item.cs_indicator_type === "Economic") {
//         const status = remarksStatus[i];
//         if (!status) {
//           showAlertMessage(`Please select Required/Not Required for "${item.cs_indicator_name}"`, "error");
//           return false;
//         }
//         if (status === "no" && !remarksText[i]) {
//           showAlertMessage(`Please enter remarks for "${item.cs_indicator_name}"`, "error");
//           return false;
//         }
//       }
//     }

//     return true;
//   };

//   const buildPayload = () => {
//     return {
//       userId: username, districtId: (roleid === "5" || roleid === "62") ? Dist : district, mandalId: mandalid || "0", level: "District",
//       indicators: criteriaData.map((item, index) => ({
//         csIndicatorId: item.cs_indicator_id,
//         isRequired:
//           item.cs_indicator_type === "Economic" ? remarksStatus[index] === "yes" ? true : remarksStatus[index] === "no" ? false : null : true,
//         remarks: remarksStatus[index] === "no" ? remarksText[index] || null : null,
//       })),
//     };
//   };

//   const handleSave = () => {
//     const payload = buildPayload();
//     payload.type = "save";
//     store.dispatch({ type: "SHOW_SPINNER" });
//     KpiService.criteriaselectiondistrictindicatorsmappingcpoLevel(payload).then((res) => {
//       const code = res.data?.SCODE
//       const desc = res.data?.SDESC
//       if (code === "01") {
//         showAlertMessage(desc || "Data Saved Successfully", "success", () => {
//           let payload = { "userId": username, "districtId": (roleid === "5" || roleid === "62") ? Dist.toString() : district.toString() }
//           fetchCriteriaAndRemarks(payload);
//         })
//       } else {
//         showAlertMessage(desc || "Save failed", "error");
//       }
//     }).catch((err) => {
//       console.error(err);
//       showAlertMessage("Something went wrong", "error");
//     }).finally(() => {
//       store.dispatch({ type: "HIDE_SPINNER" });
//     });
//   };


//   const handleForward = () => {
//     if (!validateBeforeForward()) return;

//     const payload = buildPayload();
//     if (roleid === "2") { payload.type = "forward" } else if (roleid === "64") { payload.type = "approval" }

//     store.dispatch({ type: "SHOW_SPINNER" });
//     KpiService.criteriaselectiondistrictindicatorsmappingcpoLevel(payload).then((res) => {
//       const code = res.data?.SCODE || res.data?.scode;
//       const desc = res.data?.SDESC || res.data?.sdesc;
//       if (code === "01") {
//         showAlertMessage(desc || "Data Forwarded Successfully", "success", () => {
//           let payload = { "userId": username, "districtId": district.toString() }
//           fetchCriteriaAndRemarks(payload);
//         })

//       } else {
//         showAlertMessage(res.data?.sdesc || "Failed to forward", "error");
//       }
//     }).catch((err) => {
//       console.error(err);
//       showAlertMessage("Something went wrong", "error");
//     }).finally(() => {
//       store.dispatch({ type: "HIDE_SPINNER" });
//     });

//   };


//   const handleAllAcceptance = (value) => {
//     const updatedStatus = {};

//     criteriaData.forEach((item, index) => {
//       if (item.cs_indicator_type === "Economic") { updatedStatus[index] = value; }
//     });

//     setRemarksStatus(updatedStatus);
//     setAllAcceptance(value);
//   };

//   const handleDistrictClick = (item) => {
//     setSearchDist("")
//     setDist(item?.district_id);
//     setselecteddist(item?.district_name)
//     const payload = { userId: username, districtId: item.district_id };
//     fetchCriteriaAndRemarks(payload); setShowDetailTable(true); setmaintablenb(true);
//   }

//   const handleBackCPO = () => {
//     if (!validateBeforeForward()) return;
//     const payload = buildPayload();
//     payload.type = "returntocpo";
//     KpiService.criteriaselectiondistrictindicatorsmappingcpoLevel(payload).then((res) => {
//       const code = res.data?.SCODE
//       const desc = res.data?.SDESC
//       if (code === "01") {
//         showAlertMessage(desc || "Data Saved Successfully", "success", () => {
//           let payload = { "userId": username, "districtId": Dist }
//           fetchCriteriaAndRemarks(payload);
//         })
//       } else {
//         showAlertMessage(desc || "Save failed", "error");
//       }
//     })
//       .catch(() => {
//         showAlertMessage("Something went wrong", "error");
//       });
//   }

//   const filteredDistData =
//     searchDist?.length > 0 ? distData?.filter((item) => {
//       return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchDist?.toLowerCase())); })
//       );
//     }) : distData;

//   return (
//     <>
//       <Menubar />
//       <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2>District Performance Indicators Mapping
//         <span> Acceptance Entry </span> </h2> </div> </Container>

//       <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
//         <FormikProvider value={formik}>
//           <Form onSubmit={formik.handleSubmit}>
//             <div className="py-2 px-4 mb-3">
//               <Row>

//                 {["113", "2", "3", "111", "5", "64", "62"].includes(roleid) &&
//                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label>
//                     <Select
//                       {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: (roleid === "5" || roleid === "62") ? false : true, extraOnChange: (option) => { ListTable({ userId: username, districtId: option?.id, "mandalId": "0", level: "District" }); formik.setFieldValue("district_id", option?.id); setFormikDist(option?.id) } })}
//                     /> </Col>}
//                 {["3", "111"].includes(roleid) &&
//                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
//                     <label className="mb-1 fw-bold">{ulbdeptlist.includes(roleid === "111" ? deptId : formik.values.department_id) ? "ULB" : "Mandal"}</label>
//                     <Field className="mb-3 form-control" name="mandal_id" type="text" value={selectedmandal} controlId="formBasicEmail"
//                       disabled={true} style={{ fontWeight: "bold" }} /> </Col>}

//               </Row> </div> </Form> </FormikProvider>

//         {maintablenb && showDetailTable && <>
//           <Row>

//             {((roleid === "5" || roleid === "62") && showDetailTable) && <Col xs="auto" className="ms-auto">
//               <Button variant="warning" size="sm" className="btn mb-2 warn-btn" onClick={() => { ListTable({ userId: username, districtId: formikDist, "mandalId": "0", level: "District" }) }} >
//                 <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back
//               </Button>

//             </Col>}

//           </Row>
//           <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1" >
//             <span className="style">District Performance Indicators Mapping</span>
//             {selecteddist && <span className="ms-2" style={{ fontWeight: "bold" }}>, District: {selecteddist} </span>}
//             {statusCode && ["64", "3", "2", "5", "62"].includes(roleid) && (<span className="ms-2" style={{ color: "black", fontWeight: "500" }}>, Status: {statusCode} </span>
//             )}


//           </div>

//           <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
//             <Table bordered id="my-table" className="custom-table table table-bordered sticky-table">
//               <thead>
//                 <tr className="text-center"> <th style={{ headerStyle, width: "100px" }} rowSpan={2}>Sl.No.</th> <th style={{ headerStyle, width: "200px" }} rowSpan={2}>Indicator Type</th> <th style={{ ...headerStyle, width: "200px" }} rowSpan={2}> Indicator </th> <th style={{ headerStyle, width: "300px" }} >Acceptance</th> <th style={headerStyle} rowSpan={2}>Remarks</th> </tr>
//                 <tr className="text-center">
//                   <th>
//                     <label className="me-3 text-white">
//                       <input type="radio" name="allAcceptance" value="yes"
//                         disabled={(roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62") && statusId !== 4)}
//                         checked={allAcceptance === "yes"} onChange={() => handleAllAcceptance("yes")} />
//                       {" "} All Required </label>

//                     <label className="text-white"> <input type="radio" name="allAcceptance" value="no"
//                       checked={allAcceptance === "no"}
//                       disabled={(roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62") && statusId !== 4)}

//                       onChange={() => handleAllAcceptance("no")} />{" "} All Not Required </label>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>

//                 {criteriaData?.map((item, index) => (
//                   <tr key={index}>
//                     <td className="text-center">{index + 1}</td>
//                     <td style={{ textAlign: "left" }}>
//                       {item.cs_indicator_type}
//                     </td>

//                     <td style={{ textAlign: "left", width: "200px" }}> {item.cs_indicator_name} </td>

//                     <td className="text-center">
//                       <label className="me-3">
//                         <input type="radio" name={`acceptance_${index}`} value="yes"
//                           checked={item.cs_indicator_type !== "Economic" ? true : remarksStatus[index] === "yes"}
//                           disabled={(item.cs_indicator_type !== "Economic") || ((roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62") && statusId !== 4))}


//                           required={item.is_required} onChange={() => handleAcceptanceChange(index, "yes")} />{" "} Required </label>

//                       <label> <input type="radio" name={`acceptance_${index}`} value="no"
//                         disabled={(item.cs_indicator_type !== "Economic") || ((roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62") && statusId !== 4))} checked={remarksStatus[index] === "no"} onChange={() => handleAcceptanceChange(index, "no")} />{" "} Not Required </label>
//                     </td>

//                     <td>
//                       {remarksStatus[index] === "no" && item.cs_indicator_type === "Economic" && (
//                         <textarea id={`remarks_${index}`} className="form-control" placeholder="Enter remarks" rows={2} value={remarksText[index] || ""}
//                           disabled={(roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62") && statusId !== 4)}
//                           onChange={(e) => setRemarksText({ ...remarksText, [index]: e.target.value, })} />
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>

//             </Table>

//           </div> </div> </>}
//         {((roleid === "2" && statusId === 1) || (roleid === "64" && statusId === 3)) && showDetailTable && (

//           <Row className="mt-3">
//             <Col className="text-center">
//               <div className="bottom-buttons d-flex justify-content-center mb-5">
//                 <Button variant="" size="sm" className="save-btn me-4" onClick={handleSave} > Save <FaRegSave className="ms-1 s-icon" /> </Button> <Button variant="" size="sm" className="next-btn me-4" onClick={handleForward} > {roleid === "2" ? "Forward" : "Approve"}<IoReturnDownForward style={{ fontSize: "18px", marginLeft: "5px" }} /> </Button></div>
//             </Col>
//           </Row>
//         )}



//         {((roleid === "5" || roleid === "62") && statusId === 4) && showDetailTable && (
//           <Row className="mt-3">
//             <Col className="text-center">
//               <div className="bottom-buttons d-flex justify-content-center mb-5">
//                 <Button variant="" size="sm" className="save-btn me-4" onClick={handleSave} > Save <FaRegSave className="ms-1 s-icon" /> </Button>
//                 <Button variant="" size="sm" className="next-btn me-4" onClick={handleBackCPO} >Sent Back to CPO<IoReturnDownBack style={{ fontSize: "18px", }} /> </Button></div>
//             </Col>
//           </Row>)}



//         {(roleid === "5" || roleid === "62") && !showDetailTable && (<>

//           <Row>
//             <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-1" >
//               <div class="input-group">
//                 <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
//                 <input type="text" className="form-control" value={searchDist} placeholder="Search" onChange={(event) => setSearchDist(event.target.value)} />
//               </div>
//             </Col>
//           </Row>
//           <div id="table-scroll" className="table-scroll"><div className="table-wrap">

//             <Table bordered className="custom-table">
//               <thead>
//                 <tr className="text-center"> <th>Sl.No</th> <th>District</th> <th>Total Indicators</th> <th>Required</th> <th>Not Required</th> <th>Status</th> </tr>

//               </thead>

//               <tbody>
//                 {filteredDistData?.map((item, index) => (
//                   <tr key={index}>
//                     <td className="text-center">{index + 1}</td> <td className="text-left">{item.district_name} </td> <td className="text-center">{item.total_indicators}</td> <td className="text-center">{item.required_indicators}</td> <td className="text-center">{item.remaining_indicators}</td>
//                     <td className="text-center">
//                       {item.status_code !== null ? (
//                         <button type="button" onClick={() => handleDistrictClick(item)} style={{ color: "darkblue", cursor: "pointer", textDecoration: "underline", background: "none", border: "none", padding: 0, }} >
//                           {item.status_code}
//                         </button>) : ("-")}
//                     </td>

//                   </tr>))}
//               </tbody>
//             </Table>
//           </div>
//           </div>
//         </>
//         )}



//       </Container>

//       <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
//     </>
//   );
// }

import React, { useEffect, useState } from "react"; import Menubar from "../Menubar";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { store } from "../../App"; import { AiOutlineSearch } from "react-icons/ai";
import { datetime, commonSelectProps } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik";
import MasterService from "../../Services/MasterService"; import Select from 'react-select';
import {  IoReturnDownForward } from "react-icons/io5"; import { FaRegSave } from "react-icons/fa";
import { IoIosReturnLeft } from "react-icons/io";

export default function DistrictIndicatorcom() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  let deptId = localStorage.getItem("deptid");

  let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");
  let mandalid = localStorage.getItem(ulbdeptlist.includes(deptId) ? "ulbid" : "mandalid");
  let district = localStorage.getItem("districtid");
  let roleid = localStorage.getItem("role");


  let username = localStorage.getItem("username");
  // const [selectedMandalId, setSelectedMandalId] = useState(null);
  const [dist, setDist] = useState(null);
  const [formikDist, setFormikDist] = useState(null);
const[planningCheckBox,setPlanningCheckBox]=useState({});

  const [currentdate, setCurrentdate] = useState(""); const [currenttime, setCurrenttime] = useState(""); const [deptlist, setDeptlist] = useState([]); const [distlist, setDistlist] = useState();
  const [searchDist, setSearchDist] = useState("");
  const [maintablenb, setMaintablenb] = useState(true); const [selecteddist, setSelecteddist] = useState(""); const [selectedmandal, setSelectedmandal] = useState(""); const [yearList, setYearList] = useState([]); const [monthList, setMonthList] = useState([]); const [remarksStatus, setRemarksStatus] = useState({}); const [criteriaData, setCriteriaData] = useState([]);
  const [remarksData, setRemarksData] = useState([]);
  const [remarksText, setRemarksText] = useState({}); const [allAcceptance, setAllAcceptance] = useState(""); const [isFinalSubmitted, setIsFinalSubmitted] = useState(false);
  const [statusCode, setStatusCode] = useState("");
  const [statusId, setStatusId] = useState(null);
  const [showDetailTable, setShowDetailTable] = useState(["2", "64",  "62"].includes(roleid));
  const [distData, setDistData] = useState([]);const [planningremarksText, setPlanningRemarksText] = useState({});


  const formik = useFormik({
    initialValues: { department_id: "", district_id: "", year: "", month: "" }
  });



  const ListTable = (payload) => {
    setPlanningCheckBox({});
    setSearchDist("");
    if (!payload.districtId) {
      formik.setFieldValue("district_id", "");
      setShowDetailTable(false); setMaintablenb(false); setDistData([]);
      setCriteriaData([])
      return;
    }
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.getCriteriaSelectionListData(payload).then((res) => {
      if (res.data && res.data.dataList) {
        const list = res.data.dataList; setDistData(list); setShowDetailTable(false)
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  }


  useEffect(() => {
    datetime(setCurrentdate, setCurrenttime);
    // let payload = { userId: username, districtId: district.toString() }
    let param = { userId: username }
    // if (roleid === "2" || roleid === "64") {
    //   fetchCriteriaAndRemarks(payload)
    // } else if (roleid === "5" || roleid === "62") {
    //   setMaintablenb(false)
    // }
    MasterService.getAllDepts(param).then((res) => {
      if (res.data) {
        // let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); });
        setDeptlist([{ dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? [])]);
      }
    });
    MasterService.getindicatorAcceptanceYear().then((achievvalueres) => {
      if (achievvalueres.data) {
        setYearList(achievvalueres.data);
      }
    });
    MasterService.getkpiMonths(param).then((res) => {
      if (res.data && res.data.SCODE === "01") { setMonthList(res.data.SDESC || []); }
      else { setMonthList([]); }
    });
    MasterService.getDistricts().then((res17) => {
      if (res17.data) {
        let options = res17.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
        setDistlist([{ id: "0", value: "All" }, ...(res17.data ?? [])]);
      }
    });

    if (["2", "3", "64"].includes(roleid)) { setSelecteddist(localStorage.getItem("districtname")) }
    if (["3",].includes(roleid)) { setSelectedmandal(localStorage.getItem(ulbdeptlist.includes(deptId) ? "ulbname" : "mandalname")) }

    if (["5", "62"].includes(roleid)) { formik.setFieldValue("department_id", deptId); }
    if (["2", "3", "64"].includes(roleid)) { formik.setFieldValue("district_id", district); }
  }, []);




  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white", wordBreak: "break-word" };

  const mapRemarksToState = (criteriaList, remarksList) => {
    const statusObj = {};
    const remarksObj = {};
    const remarksObjplanning = {};

    criteriaList.forEach((item, index) => {
      // ✅ match remarks
      const matched = remarksList.find(
        (r) => String(r.cs_indicator_id) === String(item.cs_indicator_id)
      );

      // ✅ set acceptance FROM criteria API
      if (item.is_required === true) {
        statusObj[index] = "yes";
      } else if (item.is_required === false) {
        statusObj[index] = "no";
      }
console.log("Criteria List:",item.cs_indicator_id, matched?.remarks, matched?.planning_remarks);

      // ✅ set remarks FROM remarks API
      remarksObj[index] = matched?.remarks || "";
      remarksObjplanning[index] = matched?.planning_remarks || "";
    });

    console.log("FINAL STATUS:", statusObj);
    console.log("FINAL REMARKS:", remarksObj);

    setRemarksStatus(statusObj);
    setRemarksText(remarksObj);
    setPlanningRemarksText(remarksObjplanning);
  };
  // const fetchCriteriaAndRemarks = (payload) => {
  //   Promise.all([
  //     KpiService.getCriteriaSelectionData({ ...payload, level: "District", }),
  //     KpiService.getCriteriaSelectionRemarks({ ...payload, level: "District", }),
  //   ]).then(([criteriaRes, remarksRes]) => {
  //     const criteriaList = criteriaRes.data?.dataList || []; const remarksList = remarksRes.data?.dataList || []; setCriteriaData(criteriaList); setRemarksData(remarksList);
  //     if (criteriaList.length > 0) { setStatusCode(criteriaList[0].status_code || ""); setStatusId(criteriaList[0].status_id || null); }
  //     mapRemarksToState(criteriaList, remarksList);
  //   }).catch(() => {
  //     showAlertMessage("Failed to load data", "error");
  //   });
  // };

  const fetchCriteriaAndRemarks = async (payload) => {
    setPlanningCheckBox({});
    try {
      const criteriaRes = await KpiService.getCriteriaSelectionData({
        ...payload,
        level: "District",
      });

      const scode = criteriaRes.data?.SCODE;

      if (scode !== "01") {
        showAlertMessage("No Data Found", "error");
        return;
      }

      const criteriaList = criteriaRes.data?.dataList || [];
      setCriteriaData(criteriaList);

      if (criteriaList.length > 0) {
        setStatusCode(criteriaList[0].status_code || "");
        setStatusId(criteriaList[0].status_id || null);
      }

      const remarksRes = await KpiService.getCriteriaSelectionRemarks({
        ...payload,
        level: "District",
      });

      const remarksList = remarksRes.data?.dataList || [];
      setRemarksData(remarksList);
console.log("Criteria List:", criteriaList,remarksList);
      mapRemarksToState(criteriaList, remarksList);

    } catch (error) {
      showAlertMessage("No Data Found", "error");
    }
  };



  const handleAcceptanceChange = (index, value) => {
    const current = remarksStatus[index];

    const updated = { ...remarksStatus, [index]: current === value ? undefined : value, };
    setRemarksStatus(updated);
    const economicItems = criteriaData.filter((item) => item.cs_indicator_type === "Economic");

    const allYes = economicItems.every((_, i) => updated[i] === "yes");

    const allNo = economicItems.every((_, i) => updated[i] === "no");

    if (allYes) setAllAcceptance("yes");
    else if (allNo) setAllAcceptance("no");
    else setAllAcceptance("");
  };
  const validateBeforeForward = () => {
    for (let i = 0; i < criteriaData.length; i++) {
      const item = criteriaData[i];
      if (item.cs_indicator_type === "Economic" && item.criterion_id !== 1) {
        const status = remarksStatus[i];
        if (!status) {
          showAlertMessage(`Please select Required/Not Required for "${item.cs_indicator_name}"`, "error");
          return false;
        }
        if (status === "no" && !remarksText[i]) {
          showAlertMessage(`Please enter remarks for "${item.cs_indicator_name}"`, "error");
          return false;
        }
      }
    }

    return true;
  };

  const buildPayload = () => {
    return {
      userId: username,finYear: formik.values.year, districtId: (roleid === "5" || roleid === "62") ? dist : district, mandalId: mandalid || "0", level: "District",
      indicators: criteriaData.map((item, index) => ({
        csIndicatorId: item.cs_indicator_id,
        
        isRequired:
         ( item.cs_indicator_type === "Economic"&& item.criterion_id != 1) ? remarksStatus[index] === "yes" ? true : remarksStatus[index] === "no" ? false : null : true,
        remarks: remarksText[index] || null ,
         planningRemarks:  planningremarksText[index] || null,
      })),
    };
  };


  const handleSave = () => {
    if(roleid === "5"){
    for (let i = 0; i < criteriaData.length; i++) {
       const item = criteriaData[i];
    if (planningCheckBox[i] && !planningremarksText[i]) {
      showAlertMessage(
        `Please enter Planning Remarks for ${item.cs_indicator_name}`,
        "warning"
      );
      return;
    }
  }
}
    const payload = buildPayload();
    payload.type = "save";
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.criteriaselectiondistrictindicatorsmappingcpoLevel(payload).then((res) => {
      const code = res.data?.SCODE
      const desc = res.data?.SDESC
      if (code === "01") {
        showAlertMessage(desc || "Data Saved Successfully", "success", () => {
          let payload = { "userId": username, finYear: formik.values.year, "districtId": (roleid === "5" || roleid === "62") ? dist.toString() : district.toString() }
          fetchCriteriaAndRemarks(payload);
        })
      } else {
        showAlertMessage(desc || "Save failed", "error");
      }
    }).catch((err) => {
      console.error(err);
      showAlertMessage("Something went wrong", "error");
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };


  const handleForward = () => {
    if(roleid!=="5"){
    if (!validateBeforeForward()) return;}

    const payload = buildPayload();
    if (roleid === "2") { payload.type = "forward" } else if (roleid === "64") { payload.type = "approval" }

    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.criteriaselectiondistrictindicatorsmappingcpoLevel(payload).then((res) => {
      const code = res.data?.SCODE || res.data?.scode;
      const desc = res.data?.SDESC || res.data?.sdesc;
      if (code === "01") {
        showAlertMessage(desc || "Data Forwarded Successfully", "success", () => {
          let payload = { "userId": username, "districtId": district.toString(), "finYear": formik.values.year }
          fetchCriteriaAndRemarks(payload);
        })

      } else {
        showAlertMessage(res.data?.sdesc || "Failed to forward", "error");
      }
    }).catch((err) => {
      console.error(err);
      showAlertMessage("Something went wrong", "error");
    }).finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });

  };


  const handleAllAcceptance = (value) => {
    const updatedStatus = {};

    criteriaData.forEach((item, index) => {
      if (item.cs_indicator_type === "Economic") { updatedStatus[index] = value; }
    });

    setRemarksStatus(updatedStatus);
    setAllAcceptance(value);
  };

  const handleDistrictClick = (item) => {
    setSearchDist("")
    setDist(item?.district_id);
    setSelecteddist(item?.district_name)
    const payload = { userId: username, districtId: item.district_id,finYear: formik.values.year };
    fetchCriteriaAndRemarks(payload); setShowDetailTable(true); setMaintablenb(true);
  }

  // const handleBackCPO = () => {
  //   if (!validateBeforeForward()) return;
  //   const payload = buildPayload();
  //   payload.type = "returntocpo";
  //   KpiService.criteriaselectiondistrictindicatorsmappingcpoLevel(payload).then((res) => {
  //     const code = res.data?.SCODE
  //     const desc = res.data?.SDESC
  //     if (code === "01") {
  //       showAlertMessage(desc || "Data Saved Successfully", "success", () => {
  //         let payload = { "userId": username, "districtId": dist }
  //         fetchCriteriaAndRemarks(payload);
  //       })
  //     } else {
  //       showAlertMessage(desc || "Save failed", "error");
  //     }
  //   })
  //     .catch(() => {
  //       showAlertMessage("Something went wrong", "error");
  //     });
  // }

  const filteredDistData =
    searchDist?.length > 0 ? distData?.filter((item) => {
      return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchDist?.toLowerCase())); })
      );
    }) : distData;

   const getMandallevelData=(year)=>{
if(!year) return;
 let payload = { userId: username, districtId: district.toString(), finYear: year }
    if (roleid === "2" || roleid === "64") {
      fetchCriteriaAndRemarks(payload)
      // setShowDetailTable(true);
    } else if (roleid === "5" || roleid === "62") {
      setMaintablenb(false)

    }
    }
  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2>District Performance Indicators Mapping
        <span> Acceptance Entry </span> </h2> </div> </Container>

      <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="py-2 px-4 mb-3">
              <Row>

          {["113", "2", "3", "111", "5", "64", "62"].includes(roleid) && (
  <Col
    xs={12}
    sm={12}
    lg={3}
    md={3}
    xl={3}
    xxl={3}
    className="district-select"
  >
    <label className="mb-1 fw-bold">District</label>

    <Select
      {...commonSelectProps({
        name: "district_id",
        options: distlist,
        value: formik.values.district_id,
        optionValueKey: "id",
        optionLabelKey: "value",
        formik,
        isDisabled:
          roleid === "5" || roleid === "62" ? false : true,

        extraOnChange: (option) => {
          formik.setFieldValue("district_id", option?.id);
          setFormikDist(option?.id);

          ListTable({
            userId: username,
            districtId: option?.id,
            mandalId: "0",
            level: "District",
            finYear: formik.values.year || "",
          });
        },
      })}
    />
  </Col>
)}

{["3", "111"].includes(roleid) && (
  <Col
    xs={12}
    sm={12}
    lg={3}
    md={3}
    xl={3}
    xxl={3}
    className="district-select"
  >
    <label className="mb-1 fw-bold">
      {ulbdeptlist.includes(
        roleid === "111"
          ? deptId
          : formik.values.department_id
      )
        ? "ULB"
        : "Mandal"}
    </label>

    <Field
      className="mb-3 form-control"
      name="mandal_id"
      type="text"
      value={selectedmandal}
      disabled={true}
      style={{ fontWeight: "bold" }}
    />
  </Col>
)}

<Col
  xs={12}
  sm={12}
  lg={3}
  md={3}
  xl={3}
  xxl={3}
  className="district-select"
>
  <label className="mb-1 fw-bold">Financial Year</label>

  <Select
    {...commonSelectProps({
      name: "year",
      options: yearList,
      value: formik.values.year,
      optionValueKey: "id",
      optionLabelKey: "value",
      formik,

      extraOnChange: (option) => {
        formik.setFieldValue("year", option?.id);

     

        if (roleid !== "5") {
          getMandallevelData(option?.id);
        }
        else{
   ListTable({
          userId: username,
          districtId:
            formik.values.district_id || formikDist,
          mandalId:
            formik.values.mandal_id || "0",
          level: "District",
          finYear: option?.id,
        });
        }
      },
    })}
  />
</Col>
              </Row> </div> </Form> </FormikProvider>

        {maintablenb && showDetailTable && <>
          <Row>

            {((roleid === "5" || roleid === "62") && showDetailTable) && <Col xs="auto" className="ms-auto">
              <Button variant="warning" size="sm" className="btn mb-2 warn-btn" onClick={() => { ListTable({ userId: username, districtId: formikDist, "mandalId": "0", level: "District",finYear: formik.values.year

               }) }} >
                <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back
              </Button>

            </Col>}

          </Row>
          <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1" >
            <span className="style">District Performance Indicators Mapping</span>
            {selecteddist && <span className="ms-2" style={{ fontWeight: "bold" }}>, District: {selecteddist} </span>}
            {statusCode && ["64", "3", "2", "5", "62"].includes(roleid) && (<span className="ms-2" style={{ color: "black", fontWeight: "500" }}>, Status: {statusCode} </span>
            )}


          </div>

          <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
            <Table bordered id="my-table" className="custom-table table table-bordered sticky-table">
              <thead>
                <tr className="text-center"> <th style={{ headerStyle, width: "100px" }} rowSpan={2}>Sl.No.</th> <th style={{ headerStyle, width: "200px" }} rowSpan={2}>Indicator Type</th> <th style={{ ...headerStyle, width: "200px" }} rowSpan={2}> Indicator </th> <th style={{ headerStyle, width: "300px" }} >Acceptance</th> 
                <th style={headerStyle} rowSpan={2}>Remarks</th>
                <th style={headerStyle} rowSpan={2}>Planning Remarks</th>
                {roleid === "5" &&<th style={headerStyle} rowSpan={2}>Edit</th>}


 </tr>
 {roleid!=="5"&&
                <tr className="text-center">
                  <th>
                    <label className="me-3 text-white">
                      <input type="radio" name="allAcceptance" value="yes"
                        disabled={(roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62") && statusId !== 4)}
                        checked={allAcceptance === "yes"} onChange={() => handleAllAcceptance("yes")} />
                      {" "} All Required </label>

                    <label className="text-white"> <input type="radio" name="allAcceptance" value="no"
                      checked={allAcceptance === "no"}
                      disabled={(roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62") && statusId !== 4)}

                      onChange={() => handleAllAcceptance("no")} />{" "} All Not Required </label>
                  </th>
                </tr>}
              </thead>
              <tbody>

                {criteriaData?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td style={{ textAlign: "left" }}>
                      {item.cs_indicator_type}
                    </td>

                    <td style={{ textAlign: "left", width: "200px" }}> {item.cs_indicator_name} </td>

                    <td className="text-center">
                      <label className="me-3">
                        <input type="radio" name={`acceptance_${index}`} value="yes"
                         
                         checked={ item.cs_indicator_type !== "Economic" || (item.cs_indicator_type === "Economic" && item.criterion_id === 1) ? true : remarksStatus[index] === "yes" }
                          disabled={(item.cs_indicator_type !== "Economic")|| (item.cs_indicator_type === "Economic" && item.criterion_id === 1) || ((roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62") && statusId !== 4)) || (roleid === "5" && !planningCheckBox[index])}


                          required={item.is_required} onChange={() => handleAcceptanceChange(index, "yes")} />{" "} Required </label>

                      <label> <input type="radio" name={`acceptance_${index}`} value="no"
                        disabled={(item.cs_indicator_type !== "Economic") ||(item.cs_indicator_type === "Economic" && item.criterion_id === 1)|| ((roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62") && statusId !== 4)) || (roleid === "5" && !planningCheckBox[index])} checked={remarksStatus[index] === "no"} onChange={() => handleAcceptanceChange(index, "no")} />{" "} Not Required </label>
                    </td>

                    <td>
                      {/* {remarksStatus[index] === "no" && item.cs_indicator_type === "Economic" && ( */}
                          {(
    (remarksStatus[index] === "no" &&
      item.cs_indicator_type === "Economic" && item.criterion_id !== 1) ||

    (remarksStatus[index] === "yes" &&
      roleid === "5" &&
      item.cs_indicator_type === "Economic" && item.criterion_id !== 1)
  ) && (
                        <textarea id={`remarks_${index}`} className="form-control" placeholder="Enter remarks" rows={2} value={remarksText[index] || ""}
                          disabled={(roleid === "2" && statusId !== 1) || (roleid === "64" && statusId !== 3) || ((roleid === "5" || roleid === "62"))}
                          onChange={(e) => setRemarksText({ ...remarksText, [index]: e.target.value, })} />
                      )}
                    </td>

                      <td>
 {/* {mainroleid==="5"&& */}
 { item.cs_indicator_type === "Economic" && item.criterion_id !== 1 && (
    <textarea
      id={`remarksplanning_${index}`}
      className="form-control"
      placeholder="Enter remarks"
      rows={2}
      title={planningremarksText[index] || ""}
      value={planningremarksText[index] || ""}
      onChange={(e) =>
        setPlanningRemarksText({
          ...planningremarksText,
          [index]: e.target.value,
        })
      }
      // disabled={
      //   (mainroleid === "3" && statusId !== 1) ||
      //   (mainroleid === "2" && statusId !== 2) ||
      //   (mainroleid === "5" && statusId !== 4)
      // }
      disabled={(roleid==="5" && planningCheckBox[index]) ? false : true}
    />
 )}
</td>

{roleid==="5"&&
<td className="text-center">
  {(item.cs_indicator_type === "Economic" && item.criterion_id !== 1)&&  (

    <input
  type="checkbox"
  className="form-check-input"
  checked={planningCheckBox[index] || false}
  onChange={(e) => {
    const isChecked = e.target.checked;

    // 🚨 Validation
    // if (isChecked && !planningremarksText[index]) {
    //   showAlertMessage(
    //     `Please enter Planning Remarks for Sl.No ${index + 1}`,
    //     "warning"
    //   );
    //   return; // stop checking
    // }

    setPlanningCheckBox({
      ...planningCheckBox,
      [index]: isChecked,
    });
  }}
/>
  )}
</td>}
                  </tr>
                ))}
              </tbody>

            </Table>

          </div> </div> </>}
        {((roleid === "2" && statusId === 1) || (roleid === "64" && statusId === 3)) && showDetailTable && (

          <Row className="mt-3">
            <Col className="text-center">
              <div className="bottom-buttons d-flex justify-content-center mb-5">
                <Button variant="" size="sm" className="save-btn me-4" onClick={handleSave} > Save <FaRegSave className="ms-1 s-icon" /> </Button> <Button variant="" size="sm" className="next-btn me-4" onClick={handleForward} > {roleid === "2" ? "Forward" : "Approve"}<IoReturnDownForward style={{ fontSize: "18px", marginLeft: "5px" }} /> </Button></div>
            </Col>
          </Row>
        )}



        {((roleid === "5" || roleid === "62") && statusId === 4) && showDetailTable && (
          <Row className="mt-3">
            <Col className="text-center">
              <div className="bottom-buttons d-flex justify-content-center mb-5">
                <Button variant="" size="sm" className="save-btn me-4" onClick={handleSave} > Save <FaRegSave className="ms-1 s-icon" /> </Button>
                {/* <Button variant="" size="sm" className="next-btn me-4" onClick={handleBackCPO} >Sent Back to CPO<IoReturnDownBack style={{ fontSize: "18px", }} /> </Button> */}
                </div>
            </Col>
          </Row>)}



        {(roleid === "5" || roleid === "62") && !showDetailTable && (<>

          <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-1" >
              <div class="input-group">
                <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                <input type="text" className="form-control" value={searchDist} placeholder="Search" onChange={(event) => setSearchDist(event.target.value)} />
              </div>
            </Col>
          </Row>
          <div id="table-scroll" className="table-scroll"><div className="table-wrap">

            <Table bordered className="custom-table">
              <thead>
                <tr className="text-center"> <th>Sl.No</th> <th>District</th> <th>Total Indicators</th> <th>Required</th> <th>Not Required</th> <th>Status</th> </tr>

              </thead>

              <tbody>
                {filteredDistData?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td> <td className="text-left">{item.district_name} </td> <td className="text-center">{item.total_indicators}</td> <td className="text-center">{item.required_indicators}</td> <td className="text-center">{item.remaining_indicators}</td>
                    <td className="text-center">
                      {item.status_code !== null ? (
                        <button type="button" onClick={() => handleDistrictClick(item)} style={{ color: "darkblue", cursor: "pointer", textDecoration: "underline", background: "none", border: "none", padding: 0, }} >
                          {item.status_code}
                        </button>) : ("-")}
                    </td>

                  </tr>))}
              </tbody>
            </Table>
          </div>
          </div>
        </>
        )}



      </Container>

      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
